import React from 'react';
import './PageIllustration.css';

const PageIllustration: React.FC<{ multiple?: boolean }> = ({ multiple = false }) => {
  return (
    <>
      <div className="page-illustration" aria-hidden="true">
        <img
          src="/images/page-illustration.svg"
          alt=""
          className="illustration-img"
        />
      </div>
      {multiple && (
        <>
          <div className="blurred-shape-gray" aria-hidden="true">
            <img
              src="/images/blurred-shape-gray.svg"
              alt=""
              className="blurred-img"
            />
          </div>
          <div className="blurred-shape" aria-hidden="true">
            <img
              src="/images/blurred-shape.svg"
              alt=""
              className="blurred-img"
            />
          </div>
        </>
      )}
    </>
  );
};

export default PageIllustration;

